import { MODEL_KEY } from 'modules/redux/constants/model-key'
import { pickObjectUtil } from 'packages/src'

/**
 * Gets the required attributes to save a instance.
 * @param  {Object} instance
 * @returns {string[]}
 */
function getRequiredRemotePropertiesModelUtil (instance) {
  return pickObjectUtil(instance, [
    MODEL_KEY.ID,
    MODEL_KEY.CLASS_NAME
  ])
}

export {
  getRequiredRemotePropertiesModelUtil
}
